import { initPhoneInputMask } from '../utils/phone_input'
import { initialProfileStorageType } from '../utils/profile_filter_context'
import { profileUnitMatchesSize } from '../utils/profile_filters'

window.total_review_pages;

$(function() {
  const $filters = $('.profle-filter-wrapper');
  const $units = $('.filter-items-section .profile-page');
  const $empty = $('.profile-filter-empty');
  const mobile = window.matchMedia('(max-width: 991.98px)');
  let appliedFilter = { type: 'all', size: '' };

  function showSizeOptions($wrapper, type) {
    $wrapper.find('.filter-right-blk').toggle(type !== 'all');
    $wrapper.find('.filter-card.self-storage, .filter-card.vehicle-storage').hide();
    if (type !== 'all') $wrapper.find('.filter-card.' + type).show();
  }

  function syncControls(type, size) {
    $filters.each(function() {
      const $wrapper = $(this);
      $wrapper.find('.storage-types input[value="' + type + '"]').prop('checked', true);
      showSizeOptions($wrapper, type);
      if (type !== 'all') {
        const $sizes = $wrapper.find('.filter-card.' + type);
        const $selected = $sizes.find('input[value="' + size + '"]');
        ($selected.length ? $selected : $sizes.find('input[value=""]')).prop('checked', true);
      } else {
        $wrapper.find('.filter-right-blk input[value=""]').prop('checked', true);
      }
    });
  }

  function applyFilter(type, size) {
    appliedFilter = { type: type, size: type === 'all' ? '' : size };
    $units.each(function() {
      const $unit = $(this);
      const matchesType = type === 'all' || $unit.hasClass(type);
      const matchesSize = profileUnitMatchesSize(type, size, $unit[0]);
      $unit.toggleClass('d-none', !matchesType || !matchesSize);
    });
    $empty.toggleClass('d-none', type === 'all' || $units.filter(':not(.d-none)').length > 0);
    syncControls(appliedFilter.type, appliedFilter.size);
  }

  function closeFilters($wrapper) {
    $wrapper.find('.filter-overlay').removeClass('active');
    $wrapper.find('.filters-detail').hide();
    $('body').removeClass('profile-filters-open');
    syncControls(appliedFilter.type, appliedFilter.size);
  }

  $filters.on('click', '.filter-btn', function() {
    const $wrapper = $(this).closest('.profle-filter-wrapper');
    syncControls(appliedFilter.type, appliedFilter.size);
    $wrapper.find('.filter-overlay').addClass('active');
    $wrapper.find('.filters-detail').show();
    $('body').addClass('profile-filters-open');
  });

  $filters.on('click', '.filter-overlay, .close-btn', function() {
    closeFilters($(this).closest('.profle-filter-wrapper'));
  });

  $filters.on('change', '.storage-types input', function() {
    const $wrapper = $(this).closest('.profle-filter-wrapper');
    const type = $(this).val();
    showSizeOptions($wrapper, type);
    if (type !== 'all') $wrapper.find('.filter-card.' + type + ' input[value=""]').prop('checked', true);
    if (!mobile.matches) applyFilter(type, '');
  });

  $filters.on('change', '.filter-right-blk input', function() {
    if (mobile.matches) return;
    const $wrapper = $(this).closest('.profle-filter-wrapper');
    const type = $wrapper.find('.storage-types input:checked').val();
    applyFilter(type, $(this).val());
  });

  $filters.on('click', '.apply-btn', function() {
    const $wrapper = $(this).closest('.profle-filter-wrapper');
    const type = $wrapper.find('.storage-types input:checked').val() || 'all';
    const size = type === 'all' ? '' : ($wrapper.find('.filter-card.' + type + ' input:checked').val() || '');
    applyFilter(type, size);
    closeFilters($wrapper);
  });

  $empty.on('click', '.reset-profile-filters', function() {
    applyFilter('all', '');
  });

  $(window).on('resize', function() {
    if (!mobile.matches) {
      $filters.find('.filter-overlay').removeClass('active');
      $filters.find('.filters-detail').css('display', '');
      $('body').removeClass('profile-filters-open');
    }
  });

  const initialType = $filters.length ? initialProfileStorageType($filters.first()[0].dataset, window.location.hash) : 'all';
  applyFilter(initialType, '');

  $('#see-more-reviews').on('click', function() {
    const pageNumber = parseInt($(this).attr('page'), 10);
    $('.customer-review.page-' + pageNumber).removeClass('d-none');
    $(this).blur();
    if (pageNumber === total_review_pages) {
      $(this).addClass('disabled').parent().addClass('disabled cursor-not-allowed');
    }
    if (pageNumber < total_review_pages) {
      $(this).attr('page', pageNumber + 1);
    }
  });
});

initPhoneInputMask();
